export const mockSpouse = {
  sex: 'male',
  name: '',
  uuid: 'db262cfd-3f78-48e7-916e-2001f3eea0a5',
  gender: 'male',
  memberType: 'Spouse',
  tobacco_use: false,
  tobacco_user: false,
  coverage_type: ['health'],
  date_of_birth: '1999-07-13',
  memberTypeUnique: 'Spouse',
  medicare_enrolled: 'false',
};

export const mockSubscriber = {
  sex: 'male',
  name: 'john',
  uuid: '4317eaca-bffc-4586-a7cf-e2482a417c3c',
  email: null,
  phone: null,
  gender: 'male',
  home_phone: null,
  memberType: 'Subscriber',
  tobacco_use: false,
  tobacco_user: false,
  coverage_type: ['health'],
  date_of_birth: new Date('1999-02-23'),
  email_address: null,
  primary_phone: null,
  memberTypeUnique: 'Subscriber',
  medicare_enrolled: 'false',
};

export const mockChildDependents = [
  {
    sex: 'male',
    name: '',
    uuid: 'bd8ac8ff-1ab2-4044-a761-ec38e995a4c4',
    gender: 'male',
    memberType: 'Dependent',
    tobacco_use: false,
    tobacco_user: false,
    coverage_type: ['health'],
    date_of_birth: '2023-02-13',
    memberTypeUnique: 'Dependent0',
  },
];

export const mockAdultDependents = [
  {
    sex: 'male',
    name: '',
    uuid: 'bd8ac8ff-1ab2-4044-a761-ec38e995a4c5',
    gender: 'male',
    memberType: 'Parent/StepParent',
    tobacco_use: false,
    tobacco_user: false,
    coverage_type: ['health'],
    date_of_birth: '1945-02-23',
    memberTypeUnique: 'Parent/StepParent0',
  },
  {
    sex: 'male',
    name: '',
    uuid: 'bd8ac8ff-1ab2-4044-a761-ec38e995a4c6',
    gender: 'male',
    memberType: 'Parent/StepParent',
    tobacco_use: false,
    tobacco_user: false,
    coverage_type: ['health'],
    date_of_birth: '1947-02-23',
    memberTypeUnique: 'Parent/StepParent1',
  },
];

export const mockDependents = [...mockChildDependents, ...mockAdultDependents];
